import {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from "react";
import { baseUrl } from "../utils/OtherUtils";
import axios from "axios";
import Cookies from "js-cookie";
//import { useAuthContext } from "./AuthContext";

const FamilyContext = createContext();

const FamilyProvider = ({ children }) => {
  //const { handleNotification } = useAuthContext();
  const [familyData, setFamilyData] = useState([]);
  const [memberData, setMemberData] = useState({
    name: "",
    contact: "",
    dob: "",
    gender: "",
    relationship: "",
  });
  const [isAddMember, setIsAddMember] = useState(false);

  // Function to create a save member
  const handleMemberSave = async (member) => {
    const url = `${baseUrl}/api/member/create-member`;

    try {
      const token = Cookies.get("token");
      const userId = Cookies.get("userId");

      if (!token || !userId) {
        console.error("Missing authentication details.");
      }

      // Include userId in the member data
      const memberWithUserId = { ...member, userId };

      // Sending a POST request to create the member
      const response = await axios.post(url, memberWithUserId, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.data.success) {
        getMembers();
        setMemberData({
          name: "",
          contact: "",
          dob: "",
          gender: "",
          relationship: "",
        });
        setIsAddMember(false);
      } else {
        console.error("Failed to create member:", response.data.message);
      }
    } catch (error) {
      console.error("Error creating member:", error);
    }
  };

  // Function to get all members
  const getMembers = useCallback(async () => {
    const url = `${baseUrl}/api/member/get-members`;

    try {
      const token = Cookies.get("token");
      const userId = Cookies.get("userId");

      if (!token || !userId) {
        console.error("Missing authentication token.");
      }

      const response = await axios.get(url, {
        params: { userId },
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.data.success) {
        setFamilyData(response?.data?.members);
      } else {
        console.error("Failed to fetch members:", response?.data?.message);
      }
    } catch (error) {
      console.error(
        "Error fetching members:",
        error.response ? error.response.data : error.message
      );
    }
  }, []);

  // Function to delete member
  const deleteMember = useCallback(
    async (memberId) => {
      const url = `${baseUrl}/api/member/delete-member/${memberId}`;

      try {
        const token = Cookies.get("token");

        if (!token) {
          console.error("Missing authentication token.");
          return;
        }

        // Sending a DELETE request to delete the member
        const response = await axios.delete(url, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (response.data.success) {
          getMembers();
        } else {
          console.error("Failed to delete member:", response.data.message);
        }
      } catch (error) {
        console.error(
          "Error deleting member:",
          error.response ? error.response.data : error.message
        );
      }
    },
    [getMembers]
  );

  useEffect(() => {
    const token = Cookies.get("token");
    const userId = Cookies.get("userId");

    if (token && userId) {
      getMembers();
    }
  }, []);

  return (
    <FamilyContext.Provider
      value={{
        memberData,
        setMemberData,
        familyData,
        setFamilyData,
        handleMemberSave,
        getMembers,
        deleteMember,
        isAddMember,
        setIsAddMember,
      }}
    >
      {children}
    </FamilyContext.Provider>
  );
};

export const useFamilyContext = () => useContext(FamilyContext);

export default FamilyProvider;
